module.exports = __webpack_public_path__ + "img/s1-4.33adafb7.jpg";